import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Index extends Component {
  componentWillMount(){
    document.body.classList.remove('light');
    document.body.classList.add('dark');
  }
  render() {
    const { page } = this.props;

    if(!page){
      return <div></div>
    }

    // strip <p> tags from content
    const slogan = page.content.rendered.replace(/<\/?p[^>]*>/g, '');
    console.log(page);
    const contact = page.acf.contact_details;

    return <div className="information transition">
      <div className="information__wrapper">
        <div className="information__slogan">
          <Link to="/">Onefortysix</Link> <span dangerouslySetInnerHTML={{__html: slogan}} />
        </div>
        <div className="information__contact" dangerouslySetInnerHTML={{__html: contact}} />
      </div>
    </div>;
  }
}

export default Index;
